import {createSlice} from "@reduxjs/toolkit";


const appSlice = createSlice({
    name: 'app',
    initialState: {
        loading: true,
        pageHeader: null,
        show_whats_new: false,
        underConstruction: false,
    },
    reducers: {
        setAppLoading(state, action) {
            state.loading = action.payload;
        },
        setPageHeader(state, action) {
            state.pageHeader = action.payload;
        },
        setWhatsNewState(state, action) {
            state.show_whats_new = action.payload;
        },
        setUnderConstruction(state, action) {
            state.underConstruction = action.payload;
        }
    }
});


export const setAppLoading = (status) => {
    return async (dispatch) => {
        dispatch(appActions.setAppLoading(status))
    }
}

export const setPageHeader = (header) => {
    return async (dispatch) => {
        dispatch(appActions.setPageHeader(header))
    }
}

export const setWhatsNewState = (show) => {
    return async (dispatch, getState) => {
        dispatch(appActions.setWhatsNewState(show))
    }
}

export const setUnderConstruction = (status) => {
    return async (dispatch, getState) => {
        dispatch(appActions.setUnderConstruction(status))
    }
}


export const appActions = appSlice.actions;
export default appSlice.reducer;
